module.exports = __webpack_public_path__ + "static/img/vs-icon.ad7ec9f0.gif";